import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BsQuestionCircle from "./svg/BsQuestionCircle";

export default function PopoverBtn({ text }) {
  return (
    <>
      {text && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip className="opacity-75">{text}</Tooltip>}
        >
          <div className="d-inline-block" onClick={(e) => e.stopPropagation()}>
            <BsQuestionCircle />
          </div>
        </OverlayTrigger>
      )}
    </>
  );
}
